import React from 'react';
import PropTypes from 'prop-types';
import { getBloodType, getStatusStyles } from "../../services/helpers";
import { useTranslation } from 'react-i18next';

const Slot = (props) => {
  const { 
    status, 
    name, 
    bloodTypes, 
    type, 
    size, 
    delay, 
    donorStatus, 
    isConfiguration, 
    title,
    reservationStatus,
    bloodTiter,
    donor,
    isReservation,
    userTiter,
    setCurrentAppointment,
    appointment,
  } = props;
  const { t } = useTranslation();

  const getSlotName = () => {
    if(type === 'Consultation') {
      return `${typeTranslation} (15m)`
    }

    return (!isConfiguration ? name : name.replace(type, typeTranslation)) || getBloodType(bloodTypes)
  }

  const getSlotType = () => {
    if(type === 'Consultation') {
      return null;
    }

    return !isConfiguration ? typeTranslation : null;
  }

  const getSlotTitle = () => {
    if(type === 'Consultation') {
      return null;
    }

    return title;
  }

  const getSlotBloodType = () => {
    if(type === 'Consultation') {
      return null;
    }

    return isConfiguration && donorStatus !== 'new' ? getBloodType(bloodTypes): null;
  }

  const getDonorStatus = () => {
    if(type === 'Consultation') {
      return null;
    }

    return donorStatus ? t(`common.donorStatus.${donorStatus}`) : null;
  }

  const getSlotStatus = () => status === 'pending' ? 'awaiting' : status;

  const getTypeName = () => {
    if(type === "N'th time draw") {
      return 'nth-time-draw'
    }
  }

  const isLowTiter = bloodTiter && bloodTiter.length === 1 && bloodTiter.find(item => item === 'low') && (userTiter === 'low' || !userTiter);

  const slotClassName = isConfiguration
    ? (reservationStatus ? `slot ${  getStatusStyles(reservationStatus) } ${ size }` : `slot ${ donorStatus } ${ size } ${ getTypeName() }`)
    : (isReservation ? `slot ${  getStatusStyles(getSlotStatus()) } ${ getSlotStatus() } ${ size } ${ delay }` : `slot ${ donor } ${ getSlotStatus() } ${ size } ${ delay } ${ getTypeName() }`)

  const typeTranslation = t(`common.appointmentType.${type}`);

  const handleCurrentAppointment = () => {
    if(setCurrentAppointment) {
      setCurrentAppointment(appointment);
    }
  }
  
  return (
    <div
      className={ slotClassName }
      onClick={ handleCurrentAppointment }
    >
      <div className="status">
        <span className="status-icon" />
      </div>
      <div className="slot-info">
        { title && <div className="slot-name slot-user">{getSlotTitle()}</div>}
        <div className="slot-name">{ getSlotName() }</div>
        <div className="slot-type">{ getSlotType() }</div>
        <div className="slot-bloodtype">{ getSlotBloodType() }</div>
        <div className={isConfiguration ? "slot-type" : "slot-status"}>
          { getDonorStatus() }
        </div>
      </div>
      { isLowTiter &&
        <div className="titer-info">LT</div>
      }
    </div>
  );
};

Slot.propTypes = {
  status: PropTypes.string,
  name: PropTypes.string,
  bloodTypes: PropTypes.array,
  type: PropTypes.string,
  size: PropTypes.string,
  delay: PropTypes.string,
};

Slot.defaultProps = {
  status: '',
  name: '',
  bloodTypes: [],
  type: '',
  size: '',
  delay: '',
};

export default Slot;
